export function linkTitle(product: NordicNest.Api.PartialProductApiModel) {
  return `${product.productName} - ${product.variantName} - ${product.brand}`;
}
